module.exports = __webpack_public_path__ + "static/media/coinvestasicom.1dd7fa8a.png";